import { useEffect } from "react";
import { useVideoContext } from "../../hooks/useVideoContext/useVideoContext";
import { useVideoPlaybackContext } from "../../hooks/useVideoPlaybackContext/useVideoPlaybackContext";

export const VideoGlobalAPI = () => {
	const { room, isConnecting, connect, disconnect } = useVideoContext();
	const playback = useVideoPlaybackContext();

	useEffect(() => {
		window.playbackProvider = { ...(window as any).playbackProvider, ...playback };

		window.conferenceProvider = {
			isConnecting: () => !!isConnecting,
			isConnected:  () => !!room,
			connect: async (token: string) => connect(token),
			disconnect: async () => disconnect()
		};

		return () => {
			delete (window as any).conferenceProvider;
		};
	}, [playback, room, isConnecting, connect, disconnect]);

	return null;
};
